import { ResizeObserver } from '@juggle/resize-observer';
import {ready} from '~/core'

ready('elements', '.section-inner, .spotLights, .pageCols-content, .g-c, .blockList', elements => {

	const ro = new ResizeObserver(entries => {
		let _breakpoints = [
			['xl', 1200],
			['lg', 992],
			['md', 768],
			['sm', 576],
			['xs', 0],
		];
	
		entries.forEach(entry => {
			_breakpoints = entry.target.dataset.breakpoints
				? JSON.parse(entry.target.dataset.breakpoints)
				: _breakpoints;
	
			_breakpoints.sort((a, b) => (a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0));
			
			_breakpoints.some(bp => {
				let width = entry.contentRect.width;
				let current = entry.target.dataset.size;
	
				if (width >= bp[1]) {
					if (current !== bp[0]) {
						entry.target.setAttribute('size', bp[0]);
					}
					return true;
				}
				return false;
			});
		});
	});
	
	ro.observe(elements);
})
